import { Component } from '@angular/core';
import { TranslateDirective } from '../shared/translate.directive';
import { Router } from '@angular/router';
import { LoginService } from '../shared/services/login.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-failed-payment',
  standalone: true,
  imports: [TranslateDirective , CommonModule],
  templateUrl: './failed-payment.component.html',
  styleUrl: './failed-payment.component.less'
})
export class FailedPaymentComponent  {
  isLogged: any;
  constructor( private router: Router ,private loginService : LoginService){
     this.loginService.contextChange.subscribe(() => {
      this.isLogged = this.loginService.isAuthenticated();
    });
    this.isLogged = this.loginService.isAuthenticated();
  }

  goToDashboard(){
    this.router.navigate(['/app-list']);
  }
}
